(function () {
  var NB = " ",
    FIN = " ";
  var R = window.MDS || {};
  var racine = R.racine || "/";
  function url(chemin) {
    return racine.replace(/\/$/, "") + "/" + chemin.replace(/^\//, "");
  }
  function euros(n) {
    var c = Math.round(n * 100) % 100;
    var e = Math.floor(n + 1e-9)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, FIN);
    return e + (c ? "," + (c < 10 ? "0" : "") + c : "") + NB + "€";
  }
  function attr(t) {
    return String(t == null ? "" : t)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;");
  }
  function petite(src, w) {
    if (!src) return "";
    src = typeof src === "string" ? src : src.url || src.src || "";
    if (!/cdn\.shopify|\/cdn\/shop\//.test(src)) return src;
    return src + (src.indexOf("?") < 0 ? "?" : "&") + "width=" + (w || 200);
  }
  function json(chemin, options) {
    return fetch(chemin, options).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) {
          var err = new Error(d.description || d.message || "Erreur");
          err.donnees = d;
          throw err;
        }
        return d;
      });
    });
  }

  var CAT = [];
  var ECO = {};
  var CLE_CATALOGUE = "mds-catalogue";
  var catalogue = null;
  try {
    var memo = JSON.parse(sessionStorage.getItem(CLE_CATALOGUE) || "null");
    if (memo && memo.d && Date.now() - memo.t < 600000) {
      CAT = memo.d.produits;
      ECO = memo.d.eco;
      catalogue = Promise.resolve(memo.d);
    }
  } catch (e) {}
  function chargerCatalogue() {
    if (catalogue) return catalogue;
    var tout = { produits: [], packs: {}, familles: {}, eco: {}, regles: [] };
    function page(n) {
      return json((R.collections || "/collections") + "/all?view=catalogue&page=" + n).then(function (d) {
        tout.produits = tout.produits.concat(d.produits || []);
        Object.assign(tout.packs, d.packs);
        Object.assign(tout.familles, d.familles);
        Object.assign(tout.eco, d.eco);
        if (d.regles) tout.regles = d.regles;
        return d.suivante && n < 20 ? page(n + 1) : tout;
      });
    }
    catalogue = page(1).then(
      function (d) {
        CAT = d.produits;
        ECO = d.eco;
        try {
          sessionStorage.setItem(CLE_CATALOGUE, JSON.stringify({ t: Date.now(), d: d }));
        } catch (e) {}
        rendre();
        return d;
      },
      function () {
        catalogue = null;
        return tout;
      },
    );
    return catalogue;
  }
  function preparerCatalogue() {
    if (catalogue || !(panier.items || []).length) return;
    if (document.readyState === "complete") chargerCatalogue();
    else
      window.addEventListener(
        "load",
        function () {
          chargerCatalogue();
        },
        { once: true },
      );
  }
  var panier = R.panierInitial || { items: [], item_count: 0, total_price: 0 };
  function fiche(id) {
    return CAT.find(function (x) {
      return x.id === id;
    });
  }
  function detail(item) {
    if (item.variant_title && !/^Default Title$/i.test(item.variant_title))
      return item.variant_title.replace(/ \/ /g, ", ");
    var f = fiche(item.handle);
    return f ? f.det : item.product_type || "";
  }
  function chargerPanier() {
    return json(url("cart.js"), { headers: { Accept: "application/json" } }).then(function (c) {
      panier = c;
      rendre();
      return c;
    });
  }
  function changer(cle, q) {
    return json(R.changer ? R.changer + ".js" : url("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: cle, quantity: q }),
    })
      .then(function (c) {
        panier = c;
        rendre();
      })
      .catch(function (e) {
        toast(e.message);
        chargerPanier();
      });
  }
  function ajouterVariante(id, q) {
    return json(R.ajout ? R.ajout + ".js" : url("cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: +id, quantity: q || 1 }] }),
    }).then(function () {
      return chargerPanier();
    });
  }

  function rendre() {
    var n = panier.item_count || 0,
      t = (panier.total_price || 0) / 100;
    document.querySelectorAll("[data-compteur]").forEach(function (el) {
      el.textContent = n;
      el.setAttribute("data-n", n);
    });
    var z = document.querySelector("[data-lignes]");
    if (!z) return;
    var html = "";
    (panier.items || []).forEach(function (p) {
      html +=
        '<div class="cart-line"><a class="cart-line__media" href="' +
        attr(p.url) +
        '"><img class="cart-line__image" src="' +
        attr(petite(p.image, 240)) +
        '" alt=""></a><div><b class="cart-line__title">' +
        attr(p.product_title) +
        '</b><div class="cart-line__details">' +
        attr(detail(p)) +
        "</div>" +
        '<div class="quantity-control"><button class="quantity-control__button" type="button" data-moins="' +
        attr(p.key) +
        '" data-q="' +
        p.quantity +
        '" aria-label="Un de moins">−</button><span class="quantity-control__value">' +
        p.quantity +
        '</span><button class="quantity-control__button" type="button" data-plus="' +
        attr(p.key) +
        '" data-q="' +
        p.quantity +
        '" aria-label="Un de plus">+</button></div>' +
        '<button type="button" class="cart-line__remove" data-retirer="' +
        attr(p.key) +
        '">Retirer</button></div><b class="cart-line__price">' +
        euros(p.final_line_price / 100) +
        "</b></div>";
    });
    z.innerHTML = html || '<p class="empty-state">Votre panier est vide.</p>';
    document.querySelectorAll("[data-total]").forEach(function (el) {
      el.textContent = euros(t);
    });
    var eco = 0;
    (panier.items || []).forEach(function (p) {
      eco += (ECO[p.variant_id] || ECO[p.product_id] || 0) * p.quantity;
    });
    document.querySelectorAll("[data-eco]").forEach(function (el) {
      el.hidden = !eco;
    });
    document.querySelectorAll("[data-eco-montant]").forEach(function (el) {
      el.textContent = euros(eco / 100);
    });
    document.querySelectorAll("[data-fois]").forEach(function (el) {
      el.textContent = t ? "ou en 3" + NB + "fois sans frais avec Klarna, sous réserve d'acceptation" : "";
    });
    var bas = document.querySelector("[data-drawer-footer]");
    if (bas) bas.hidden = !t;
    associer();
    preparerCatalogue();
  }

  function associer() {
    if (window.MdsComplements) window.MdsComplements.rendre(panier, chargerCatalogue);
    else
      document.querySelectorAll("[data-associer]").forEach(function (b) {
        b.hidden = true;
      });
  }

  var dernierFocus = null;
  function ouvrir(id) {
    var t = document.getElementById(id);
    if (!t) return;
    dernierFocus = document.activeElement;
    t.classList.add("is-open", "was-opened");
    t.setAttribute("aria-hidden", "false");
    document.body.classList.add("has-open-drawer");
    var f = t.querySelector("button, a");
    if (f) f.focus({ preventScroll: true });
  }
  function fermer() {
    document.querySelectorAll(".drawer.is-open").forEach(function (t) {
      t.classList.remove("is-open");
      t.setAttribute("aria-hidden", "true");
    });
    document.body.classList.remove("has-open-drawer");
    if (dernierFocus) dernierFocus.focus({ preventScroll: true });
  }

  function envoyerShopify(champs, repli) {
    var fd = new FormData();
    fd.append("utf8", "✓");
    Object.keys(champs).forEach(function (k) {
      fd.append(k, champs[k]);
    });
    return fetch(url("contact"), { method: "POST", body: fd, credentials: "same-origin" }).then(function (r) {
      if (/challenge/.test(r.url) && repli) repli();
      return r.ok;
    });
  }
  function formNatif(champs) {
    var f = document.createElement("form");
    f.method = "post";
    f.action = url("contact");
    f.hidden = true;
    Object.keys(champs).forEach(function (k) {
      var i = document.createElement("input");
      i.type = "hidden";
      i.name = k;
      i.value = champs[k];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }
  function prevenir() {
    var ligne = document.querySelector("[data-repere]"),
      f = document.querySelector("[data-form-prevenir]");
    if (!f) {
      f = document.createElement("form");
      f.className = "notify-form";
      f.setAttribute("data-form-prevenir", "");
      f.noValidate = true;
      f.innerHTML =
        '<label class="notify-form__label" for="mail-prevenir">Votre email, utilisé seulement pour vous prévenir de son retour</label><div class="notify-form__row"><input class="notify-form__input" id="mail-prevenir" type="email" autocomplete="email" placeholder="vous@exemple.fr" required><button class="button" type="submit">Me prévenir</button></div><p class="form-message notify-form__message" role="status"></p>';
      ligne.parentNode.insertBefore(f, ligne.nextSibling);
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var v = f.querySelector("input").value.trim(),
          m = f.querySelector(".notify-form__message");
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
          m.textContent = "Cette adresse email ne semble pas complète.";
          return;
        }
        var va = varianteChoisie();
        var champs = {
          form_type: "contact",
          "contact[email]": v,
          "contact[tags]": "prevenir-retour",
          "contact[body]":
            "Me prévenir du retour : " +
            (P ? P.nom : "") +
            (va && va.options ? " (" + va.options.join(", ") + ", variante " + va.id + ")" : "") +
            "\n" +
            location.href,
        };
        m.textContent = "Envoi...";
        envoyerShopify(champs, function () {
          formNatif(champs);
        })
          .then(function (ok) {
            m.textContent = ok
              ? "C'est noté : nous vous écrivons à " + v + " dès son retour."
              : "L'envoi n'a pas abouti. Écrivez-nous, nous répondons sous un jour ouvrable.";
            if (ok) f.querySelector("input").value = "";
          })
          .catch(function () {
            formNatif(champs);
          });
      });
    }
    window.scrollTo({ top: f.getBoundingClientRect().top + window.scrollY - 160, behavior: "smooth" });
    f.querySelector("input").focus({ preventScroll: true });
  }

  document.querySelectorAll("[data-lettre]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      var i = f.querySelector('input[type="email"]'),
        v = i.value.trim(),
        m = f.parentNode.querySelector(".newsletter__message");
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        e.preventDefault();
        if (m) m.textContent = "Cette adresse email ne semble pas complète.";
        return;
      }
      try {
        var l = JSON.parse(localStorage.getItem("mds-inscrits") || "[]");
        l.push({ date: Date.now(), source: "lettre" });
        localStorage.setItem("mds-inscrits", JSON.stringify(l));
      } catch (err) {}
    });
  });
  if (document.querySelector("[data-inscrit]")) {
    var lettre = document.getElementById("lettre");
    if (lettre) lettre.scrollIntoView({ block: "center" });
  }
  function toast(m) {
    var t = document.querySelector(".toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "toast";
      t.setAttribute("role", "status");
      document.body.appendChild(t);
    }
    t.textContent = m;
    t.classList.add("is-visible");
    clearTimeout(t._t);
    t._t = setTimeout(function () {
      t.classList.remove("is-visible");
    }, 3500);
  }

  var P = window.PRODUIT || null;
  var choix = null;
  if (P && (P.tailles || P.coloris)) {
    var v0 =
      P.variantes.find(function (v) {
        return v.id === P.vid;
      }) || P.variantes[0];
    choix = { taille: P.posT >= 0 ? v0.options[P.posT] : null, coloris: P.posC >= 0 ? cle(v0.options[P.posC]) : null };
  }
  var decodees = {};
  function decoder(u) {
    if (!u) return Promise.resolve();
    if (!decodees[u]) {
      var x = new Image();
      x.decoding = "async";
      x.src = u;
      decodees[u] = x.decode
        ? x.decode().catch(function () {})
        : new Promise(function (ok) {
            x.onload = x.onerror = ok;
          });
    }
    return decodees[u];
  }
  function prechargerColoris(id) {
    if (!P || !P.coloris) return;
    var c = P.coloris.find(function (x) {
      return x.id === id;
    });
    if (!c || !c.photos) return;
    c.photos.slice(0, 2).forEach(decoder);
  }
  ["pointerover", "touchstart", "focusin"].forEach(function (ev) {
    document.addEventListener(
      ev,
      function (e) {
        var b = e.target.closest && e.target.closest("[data-coloris]");
        if (b) prechargerColoris(b.getAttribute("data-coloris"));
      },
      { passive: true },
    );
  });
  function cle(t) {
    return String(t)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }
  function colorisChoisi() {
    return P && P.coloris
      ? P.coloris.find(function (c) {
          return c.id === choix.coloris;
        }) || P.coloris[0]
      : null;
  }
  function variante(taille, colorisId) {
    return P.variantes.find(function (v) {
      return (P.posT < 0 || v.options[P.posT] === taille) && (P.posC < 0 || cle(v.options[P.posC]) === colorisId);
    });
  }
  function varianteChoisie() {
    if (!P) return null;
    if (!P.tailles)
      return (
        P.variantes.find(function (v) {
          return v.id === P.vid;
        }) || P.variantes[0]
      );
    return variante(choix.taille, choix.coloris);
  }

  function ajouter() {
    var q = 1,
      s = document.querySelector("[data-qte]");
    if (s) q = parseInt(s.value, 10) || 1;
    var v = varianteChoisie();
    if (!v) return;
    var boutons = document.querySelectorAll("[data-ajouter]");
    boutons.forEach(function (b) {
      b.disabled = true;
    });
    ajouterVariante(v.id, q)
      .then(function () {
        ouvrir("panier");
        boutons.forEach(function (btn) {
          if (btn.hasAttribute("data-prevenir")) return;
          var avant = btn.textContent;
          btn.classList.add("is-added");
          btn.textContent = "Ajouté au panier";
          clearTimeout(btn._t);
          btn._t = setTimeout(function () {
            btn.classList.remove("is-added");
            btn.textContent = avant;
          }, 1800);
        });
      })
      .catch(function (e) {
        toast(e.message || "Ajout impossible pour le moment.");
      })
      .then(function () {
        boutons.forEach(function (b) {
          b.disabled = false;
        });
      });
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest("button, a");
    if (!b) return;
    if (b.hasAttribute("data-panier")) {
      e.preventDefault();
      rendre();
      ouvrir("panier");
      chargerPanier().catch(function () {});
    }
    if (b.hasAttribute("data-menu")) {
      ouvrir("menu-mobile");
    }
    if (b.hasAttribute("data-fermer")) {
      fermer();
    }
    if (b.hasAttribute("data-ajouter")) {
      if (b.hasAttribute("data-prevenir")) prevenir(b);
      else ajouter();
    }
    if (b.hasAttribute("data-plus")) {
      changer(b.getAttribute("data-plus"), (+b.getAttribute("data-q") || 0) + 1);
    }
    if (b.hasAttribute("data-moins")) {
      changer(b.getAttribute("data-moins"), Math.max(0, (+b.getAttribute("data-q") || 1) - 1));
    }
    if (b.hasAttribute("data-ajout-rapide")) {
      e.preventDefault();
      ajouterVariante(b.getAttribute("data-ajout-rapide"), 1).catch(function (err) {
        toast(err.message);
      });
    }
    if (b.hasAttribute("data-retirer")) {
      changer(b.getAttribute("data-retirer"), 0);
    }
    if (b.hasAttribute("data-defile")) {
      var pi = b.closest("[data-carrousel]").querySelector("[data-piste]");
      pi.scrollBy({ left: +b.getAttribute("data-defile") * pi.clientWidth * 0.8, behavior: "smooth" });
    }
    if (b.hasAttribute("data-qte-plus") || b.hasAttribute("data-qte-moins")) {
      var qi = document.querySelector("[data-qte]");
      qi.value = Math.max(1, Math.min(9, (parseInt(qi.value, 10) || 1) + (b.hasAttribute("data-qte-plus") ? 1 : -1)));
    }
    if (b.hasAttribute("data-coloris") && choix) {
      choix.coloris = b.getAttribute("data-coloris");
      majVariante(true);
    }
    if (b.hasAttribute("data-choix-taille") && choix) {
      choix.taille = b.getAttribute("data-choix-taille");
      majVariante(false);
    }
    if (b.hasAttribute("data-groupe")) {
      var g = b.getAttribute("data-groupe"),
        deja = b.getAttribute("aria-pressed") === "true";
      document.querySelectorAll('[data-groupe="' + g + '"]').forEach(function (x) {
        x.setAttribute("aria-pressed", "false");
      });
      if (!deja) b.setAttribute("aria-pressed", "true");
      filtrer();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") fermer();
  });
  document.querySelectorAll("[data-overlay]").forEach(function (v) {
    v.addEventListener("click", fermer);
  });

  var C = R.collections || "/collections";
  var RAYONS = [
    [/table.*basse|basse/, C + "/tables-basses"],
    [/tapis|albi|revel|lautrec|moissac|millau/, C + "/tapis"],
    [/rideau|voilage/, C + "/rideaux"],
    [/plaid/, C + "/plaids"],
    [/table|victor|l[eé]on/, C + "/tables"],
    [/buffet|enfilade|basile|margot|armand/, C + "/buffets"],
    [/tv|t[eé]l[eé]/, C + "/meubles-tv"],
    [/vitrine/, C + "/vitrines"],
    [/lit|chevet|colombe|chambre/, C + "/lits-et-chevets"],
  ];
  function sans(t) {
    return t.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  }
  function chercherLocal(q) {
    var mots = sans(q).split(/\s+/).filter(Boolean);
    if (!mots.length) return [];
    return CAT.map(function (c) {
      var t = sans(c.nom + " " + c.fam + " " + c.det),
        n = 0;
      mots.forEach(function (m) {
        if (t.indexOf(m) >= 0) n++;
      });
      return [n, c];
    })
      .filter(function (x) {
        return x[0] === mots.length;
      })
      .map(function (x) {
        var c = x[1];
        return { url: c.url, img: c.img, nom: c.nom, prix: c.prix, des: !c.simple };
      });
  }
  function chercher(q) {
    if (!q.trim()) return Promise.resolve([]);
    var u =
      (R.suggestions || url("search/suggest")) +
      ".json?q=" +
      encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last";
    return json(u)
      .then(function (d) {
        var l = (d.resources && d.resources.results && d.resources.results.products) || [];
        return l.map(function (p) {
          var px = (p.variants || [])
            .filter(function (x) {
              return x.available;
            })
            .map(function (x) {
              return parseFloat(x.price);
            });
          if (!px.length) px = [parseFloat(p.price_min || p.price)];
          var pmin = Math.min.apply(null, px);
          return {
            url: p.url,
            img: p.image || (p.featured_image && p.featured_image.url),
            nom: p.title,
            prix: pmin,
            des: px.some(function (y) {
              return y !== pmin;
            }),
          };
        });
      })
      .catch(function () {
        return chargerCatalogue().then(function () {
          return chercherLocal(q);
        });
      });
  }
  document.querySelectorAll("[data-recherche]").forEach(function (form) {
    var input = form.querySelector('input[type="search"]'),
      box = form.querySelector("[data-suggestions]"),
      dernier = [],
      minuteur = null,
      n = 0;
    input.addEventListener("input", function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        var jeton = ++n;
        chercher(input.value).then(function (r) {
          if (jeton !== n) return;
          dernier = r;
          r = r.slice(0, 5);
          if (!box) return;
          box.hidden = !r.length;
          box.innerHTML = r
            .map(function (c) {
              return (
                '<a class="search-suggestions__item" href="' +
                attr(c.url) +
                '"><img class="search-suggestions__image" src="' +
                attr(petite(c.img, 120)) +
                '" alt=""><span><b class="search-suggestions__name">' +
                attr(c.nom) +
                "</b>" +
                (c.des ? "Dès " : "") +
                euros(c.prix) +
                "</span></a>"
              );
            })
            .join("");
        });
      }, 160);
    });
    input.addEventListener("blur", function () {
      setTimeout(function () {
        if (box) box.hidden = true;
      }, 200);
    });
    form.addEventListener("submit", function (e) {
      var q = sans(input.value);
      if (!q.trim()) {
        e.preventDefault();
        return;
      }
      if (dernier.length === 1) {
        e.preventDefault();
        location.href = dernier[0].url;
        return;
      }
      for (var i = 0; i < RAYONS.length; i++)
        if (RAYONS[i][0].test(q) && q.split(/\s+/).length === 1) {
          e.preventDefault();
          location.href = RAYONS[i][1];
          return;
        }
    });
  });

  function selSync(sel) {
    var w = sel._sel;
    if (!w) return;
    var o = sel.options[sel.selectedIndex];
    if (!o) return;
    w.querySelector(".custom-select__value").innerHTML =
      (o.getAttribute("data-img")
        ? '<img class="custom-select__image" src="' + attr(o.getAttribute("data-img")) + '" alt="">'
        : "") +
      '<span class="custom-select__value-text">' +
      attr(o.textContent) +
      "</span>";
    w.querySelectorAll("[role=option]").forEach(function (li) {
      li.setAttribute("aria-selected", li.getAttribute("data-v") === sel.value);
    });
  }
  function selFermer(w) {
    w.classList.remove("is-open");
    w.querySelector(".custom-select__button").setAttribute("aria-expanded", "false");
  }
  function selCustom(sel) {
    if (sel._sel) return;
    var w = document.createElement("div");
    w.className = "custom-select" + (sel.closest("[data-barre-achat]") ? " custom-select--up" : "");
    var lab = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
    w.innerHTML =
      '<button type="button" class="custom-select__button" aria-haspopup="listbox" aria-expanded="false"' +
      (lab ? ' aria-label="' + attr(lab.textContent) + '"' : "") +
      '><span class="custom-select__value"></span><i class="custom-select__icon ph ph-caret-down" aria-hidden="true"></i></button><ul class="custom-select__list" role="listbox" aria-label="' +
      attr(lab ? lab.textContent : sel.getAttribute("aria-label") || "Choix") +
      '"></ul>';
    var ul = w.querySelector("ul");
    Array.prototype.forEach.call(sel.options, function (o) {
      var li = document.createElement("li");
      li.className = "custom-select__option";
      li.setAttribute("role", "option");
      li.setAttribute("data-v", o.value);
      li.tabIndex = -1;
      li.innerHTML =
        (o.getAttribute("data-img")
          ? '<img class="custom-select__image" src="' + attr(o.getAttribute("data-img")) + '" alt="" loading="lazy">'
          : "") +
        '<span class="custom-select__option-text">' +
        attr(o.textContent) +
        "</span>" +
        '<i class="custom-select__check ph ph-check" aria-hidden="true"></i>';
      ul.appendChild(li);
    });
    sel.parentNode.insertBefore(w, sel);
    w.appendChild(sel);
    sel.classList.add("custom-select__native");
    sel.tabIndex = -1;
    sel._sel = w;
    var btn = w.querySelector(".custom-select__button");
    if (sel.closest("[data-barre-achat]")) btn.tabIndex = -1;
    btn.addEventListener("click", function () {
      var o = !w.classList.contains("is-open");
      document.querySelectorAll(".custom-select.is-open").forEach(selFermer);
      if (o) {
        w.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
        var a = ul.querySelector("[aria-selected=true]") || ul.firstChild;
        a.focus();
      }
    });
    ul.addEventListener("click", function (e) {
      var li = e.target.closest("[role=option]");
      if (!li) return;
      sel.value = li.getAttribute("data-v");
      selSync(sel);
      selFermer(w);
      btn.focus();
      sel.dispatchEvent(new Event("change", { bubbles: true }));
    });
    ul.addEventListener("keydown", function (e) {
      var li = document.activeElement;
      if (!li || li.getAttribute("role") !== "option") return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        (li.nextElementSibling || li).focus();
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        (li.previousElementSibling || li).focus();
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        li.click();
      }
      if (e.key === "Escape") {
        selFermer(w);
        btn.focus();
      }
    });
    selSync(sel);
  }
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".custom-select")) document.querySelectorAll(".custom-select.is-open").forEach(selFermer);
  });
  document
    .querySelectorAll("select[data-barre-coloris], select[data-barre-taille], select[data-tri]")
    .forEach(selCustom);

  function recadrer(im, cadre) {
    Array.prototype.slice.call(im.classList).forEach(function (k) {
      if (k.indexOf("image-crop--") === 0) im.classList.remove(k);
    });
    if (cadre) im.classList.add(cadre);
  }
  function pastilles(racineEl) {
    (racineEl || document).querySelectorAll("[data-tuile] [data-c]").forEach(function (pa) {
      if (pa._ok) return;
      pa._ok = true;
      var tuile = pa.closest("[data-tuile]"),
        base = tuile.getAttribute("href").split("?")[0];
      function montrer() {
        var im = tuile.querySelector(".product-card__image--cutout"),
          am = tuile.querySelector(".product-card__image--scene");
        if (im) {
          im.removeAttribute("srcset");
          im.src = pa.getAttribute("data-img");
          recadrer(im, pa.getAttribute("data-crop"));
        }
        if (am) {
          am.removeAttribute("srcset");
          am.src = pa.getAttribute("data-amb");
        }
        tuile.querySelectorAll("[data-c]").forEach(function (x) {
          x.classList.toggle("is-active", x === pa);
        });
        tuile.setAttribute("href", base + "?variant=" + pa.getAttribute("data-c"));
      }
      pa.addEventListener("mouseenter", montrer);
      pa.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        montrer();
      });
    });
  }
  pastilles();

  function majVariante(nouvellesPhotos) {
    if (!P || !(P.tailles || P.coloris)) return;
    var c = colorisChoisi();
    var v = variante(choix.taille, choix.coloris);
    if (!v) {
      v = P.variantes.find(function (x) {
        return P.posC < 0 || cle(x.options[P.posC]) === choix.coloris;
      });
      if (v) choix.taille = v.options[P.posT];
    }
    if (!v) return;
    var stock = v.dispo;
    document.querySelectorAll("[data-coloris]").forEach(function (x) {
      x.setAttribute("aria-pressed", x.getAttribute("data-coloris") === choix.coloris);
    });
    document.querySelectorAll("[data-choix-taille]").forEach(function (x) {
      var tt = x.getAttribute("data-choix-taille"),
        vt = variante(tt, choix.coloris),
        s = vt && vt.dispo;
      x.setAttribute("aria-pressed", tt === choix.taille);
      x.classList.toggle("is-sold-out", !s);
      x.querySelector(".size-options__price").textContent = !vt ? "" : s ? euros(vt.prix / 100) : "Épuisé";
    });
    var sc = document.querySelector("[data-barre-coloris]");
    if (sc && c) {
      sc.value = c.id;
      selSync(sc);
    }
    var st = document.querySelector("[data-barre-taille]");
    if (st) {
      st.value = choix.taille;
      selSync(st);
    }
    var nomC = document.querySelector("[data-nom-coloris]");
    if (nomC && c) nomC.textContent = c.nom;
    var nomT = document.querySelector("[data-nom-taille]");
    if (nomT) nomT.textContent = choix.taille;
    document.querySelectorAll("[data-affiche-prix]").forEach(function (el) {
      el.textContent = euros(v.prix / 100);
    });
    document.querySelectorAll("[data-prix-fois]").forEach(function (el) {
      el.textContent = euros(Math.floor(v.prix / 3) / 100);
    });
    if (v.eco)
      document.querySelectorAll("[data-eco-fiche]").forEach(function (el) {
        el.textContent = euros(v.eco / 100);
      });
    document.querySelectorAll("[data-ajouter]").forEach(function (btn) {
      if (stock) {
        btn.removeAttribute("data-prevenir");
        btn.textContent = "Ajouter au panier";
      } else {
        btn.setAttribute("data-prevenir", "");
        btn.textContent = "Me prévenir du retour";
      }
    });
    var poids = document.querySelector("[data-poids]");
    if (poids)
      poids.textContent = v.poids ? (Math.round(v.poids / 10) / 100 + "").replace(".", ",") + NB + "kg" : "inconnu";
    var ref = document.querySelector("[data-ref]");
    if (ref) ref.textContent = v.sku || "";
    P.vid = v.id;
    document.querySelectorAll("[data-soeur]").forEach(function (lien) {
      var id = "";
      lien
        .getAttribute("data-soeur")
        .split("|")
        .forEach(function (paire) {
          var i = paire.lastIndexOf("=");
          if (i > 0 && paire.slice(0, i) === choix.taille) id = paire.slice(i + 1);
        });
      lien.setAttribute("href", lien.getAttribute("data-base") + (id ? "?variant=" + id : ""));
    });
    try {
      var u = new URL(location.href);
      u.searchParams.set("variant", v.id);
      history.replaceState(history.state, "", u.toString());
    } catch (e) {}
    if (nouvellesPhotos && c && c.photos) {
      document.querySelectorAll("[data-zoom]").forEach(function (f, i) {
        var im = f.querySelector("img"),
          src = c.photos[i];
        if (!src) return;
        f._attendu = src;
        var poser = function () {
          if (f._attendu !== src) return;
          im.removeAttribute("srcset");
          im.src = src;
          if (c.hd && c.hd[i]) im.setAttribute("data-hd", c.hd[i]);
          if (i === 0 && c.cadre) recadrer(im, c.cadre);
          if (window.MdsVisionneuse) window.MdsVisionneuse();
        };
        decoder(src).then(poser, poser);
      });
    }
  }
  if (P && (P.tailles || P.coloris)) majVariante(false);
  document.addEventListener("change", function (e) {
    if (!choix) return;
    if (e.target.hasAttribute("data-barre-taille")) {
      choix.taille = e.target.value;
      majVariante(false);
    }
    if (e.target.hasAttribute("data-barre-coloris")) {
      choix.coloris = e.target.value;
      majVariante(true);
    }
  });

  function filtrer() {
    var t = document.querySelectorAll("[data-tuile]");
    if (!t.length) return;
    var actifs = {};
    document.querySelectorAll('[data-groupe][aria-pressed="true"]').forEach(function (x) {
      actifs[x.getAttribute("data-groupe")] = x.getAttribute("data-valeur");
    });
    var n = 0;
    t.forEach(function (el) {
      var ok = true;
      for (var g in actifs) if ((el.getAttribute("data-" + g) || "").split(" ").indexOf(actifs[g]) < 0) ok = false;
      el.classList.toggle("is-hidden", !ok);
      if (ok) n++;
    });
    var c = document.querySelector("[data-compte]");
    if (c && Object.keys(actifs).length)
      c.textContent = n + NB + (n > 1 ? c.getAttribute("data-pluriel") : c.getAttribute("data-singulier"));
  }
  var depart = new URLSearchParams(location.search).get("taille");
  if (depart) {
    var pre = document.querySelector('[data-groupe][data-valeur="' + depart + '"]');
    if (pre) pre.setAttribute("aria-pressed", "true");
  }
  var tri = document.querySelector("[data-tri]");
  if (tri)
    tri.addEventListener("change", function () {
      var g = document.querySelector("[data-grille]"),
        cs = Array.prototype.slice.call(g.children);
      cs.sort(function (a, b) {
        if (tri.value === "prix-asc") return (a.dataset.prix || 1e9) - (b.dataset.prix || 1e9);
        if (tri.value === "prix-desc") return (b.dataset.prix || -1) - (a.dataset.prix || -1);
        if (tri.value === "largeur") return a.dataset.l - b.dataset.l;
        return (a.dataset.ordre || 1e9) - (b.dataset.ordre || 1e9);
      });
      cs.forEach(function (c) {
        g.appendChild(c);
      });
    });

  var MOIS = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ];
  function ouvres(n) {
    var d = new Date(),
      c = 0;
    while (c < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() % 6) c++;
    }
    return d;
  }
  function periode(a) {
    var d1 = ouvres(+a[0]),
      d2 = ouvres(+a[1]);
    return d1.getMonth() === d2.getMonth()
      ? "entre le " + d1.getDate() + " et le " + d2.getDate() + NB + MOIS[d2.getMonth()]
      : "entre le " + d1.getDate() + NB + MOIS[d1.getMonth()] + " et le " + d2.getDate() + NB + MOIS[d2.getMonth()];
  }
  document.querySelectorAll("[data-estimation]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var cp = f.querySelector("input").value.trim(),
        r = f.parentNode.querySelector(".delivery-estimate__result");
      if (!/^\d{5}$/.test(cp)) {
        r.textContent = "Entrez un code postal à 5 chiffres.";
        return;
      }
      if (window.mdsZoneCp) window.mdsZoneCp(cp);
      if (/^(20|9[78])/.test(cp)) {
        r.textContent =
          "Désolé, nous ne livrons pas encore la Corse ni l'outre-mer. Nous livrons la France métropolitaine.";
        return;
      }
      r.innerHTML =
        "Au " +
        cp +
        " : <b>livraison offerte</b>, " +
        (f.getAttribute("data-estimation") === "3-6"
          ? "sous 3" + NB + "à" + NB + "6" + NB + "jours ouvrés"
          : "sous 2" + NB + "à" + NB + "3" + NB + "semaines") +
        " après la confirmation de votre commande.";
    });
  });

  var large = window.matchMedia("(min-width: 1001px)");
  document.querySelectorAll("[data-zoom]").forEach(function (f) {
    var lent = document.createElement("span");
    lent.className = "product-gallery__lens";
    f.appendChild(lent);
    var K = 1.8;
    function placer(e) {
      if (!large.matches) return;
      var im = f.querySelector("img"),
        fr = f.getBoundingClientRect(),
        ir = im.getBoundingClientRect(),
        L = lent.offsetWidth;
      var cx = Math.max(ir.left, Math.min(e.clientX, ir.right)),
        cy = Math.max(ir.top, Math.min(e.clientY, ir.bottom));
      lent.style.left = cx - fr.left - L / 2 + "px";
      lent.style.top = cy - fr.top - L / 2 + "px";
      lent.style.backgroundImage = "url(" + JSON.stringify(im.getAttribute("data-hd") || im.currentSrc || im.src) + ")";
      lent.style.backgroundSize = ir.width * K + "px " + ir.height * K + "px";
      lent.style.backgroundPosition = -(cx - ir.left) * K + L / 2 + "px " + (-(cy - ir.top) * K + L / 2) + "px";
    }
    f.addEventListener("mouseenter", function (e) {
      if (!large.matches) return;
      f.classList.add("is-zooming");
      placer(e);
    });
    f.addEventListener("mouseleave", function () {
      f.classList.remove("is-zooming");
    });
    f.addEventListener("mousemove", placer);
  });
  var gal3 = document.querySelector("[data-galerie]"),
    pts = document.querySelectorAll("[data-gallery-dots] > span");
  if (gal3)
    gal3.addEventListener(
      "scroll",
      function () {
        var i = Math.round(gal3.scrollLeft / gal3.clientWidth);
        pts.forEach(function (p, j) {
          p.classList.toggle("is-active", j === i);
        });
      },
      { passive: true },
    );
  function carrousels(racineEl) {
    (racineEl || document).querySelectorAll("[data-carrousel]").forEach(function (c) {
      var piste = c.querySelector("[data-piste]"),
        g = c.querySelector('[data-defile="-1"]'),
        d = c.querySelector('[data-defile="1"]');
      function maj() {
        g.disabled = piste.scrollLeft < 8;
        d.disabled = piste.scrollLeft + piste.clientWidth > piste.scrollWidth - 8;
      }
      piste.addEventListener("scroll", maj, { passive: true });
      maj();
    });
  }
  carrousels();

  var barre = document.querySelector("[data-barre-achat]"),
    repere = document.querySelector("[data-repere]");
  if ("IntersectionObserver" in window && barre && repere) {
    var dessous = new Set(),
      repereVu = true;
    var majBarre = function () {
      var v = !repereVu && (dessous.size > 0 || window.innerWidth < 768);
      barre.classList.toggle("is-visible", v);
      barre.setAttribute("aria-hidden", v ? "false" : "true");
      barre.querySelectorAll("button, select").forEach(function (x) {
        x.tabIndex = v ? 0 : -1;
      });
    };
    var hEnt = (document.querySelector(".site-header") || {}).offsetHeight || 0;
    new IntersectionObserver(
      function (en) {
        repereVu = en[0].isIntersecting && en[0].intersectionRatio >= 0.6;
        majBarre();
      },
      { rootMargin: "-" + hEnt + "px 0px 0px 0px", threshold: [0, 0.6, 1] },
    ).observe(repere);
    var cibles = [],
      el = repere.nextElementSibling;
    while (el) {
      cibles.push(el);
      el = el.nextElementSibling;
    }
    var bloc = repere.closest(".container");
    el = bloc && bloc.nextElementSibling;
    while (el && !el.hasAttribute("data-barre-achat")) {
      cibles.push(el);
      el = el.nextElementSibling;
    }
    var sec = repere.closest(".shopify-section");
    el = sec && sec.nextElementSibling;
    while (el) {
      cibles.push(el);
      el = el.nextElementSibling;
    }
    var obs = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) dessous.add(x.target);
        else dessous.delete(x.target);
      });
      majBarre();
    });
    cibles.forEach(function (c) {
      obs.observe(c);
    });
  }

  document.querySelectorAll("[data-recommandations]").forEach(function (s) {
    var g = s.querySelector(".product-grid");
    if (!g || g.children.length) return;
    fetch(s.getAttribute("data-url"))
      .then(function (r) {
        return r.text();
      })
      .then(function (t) {
        var d = document.createElement("div");
        d.innerHTML = t;
        var g2 = d.querySelector("[data-recommandations] .product-grid");
        if (g2 && g2.children.length) {
          g.innerHTML = g2.innerHTML;
          pastilles(g);
        } else s.hidden = true;
      })
      .catch(function () {
        s.hidden = true;
      });
  });

  var vues = Array.prototype.slice.call(document.querySelectorAll("[data-zoom]"));
  if (vues.length) {
    var vi = document.createElement("div");
    vi.className = "lightbox";
    vi.setAttribute("role", "dialog");
    vi.setAttribute("aria-modal", "true");
    vi.setAttribute("aria-label", "Photos en grand");
    vi.hidden = true;
    vi.innerHTML =
      '<button type="button" class="lightbox__close" data-lightbox-close aria-label="Fermer"><i class="lightbox__close-icon ph ph-x"></i></button><button type="button" class="lightbox__arrow lightbox__arrow--prev" data-lightbox-step="-1" aria-label="Photo précédente"><i class="ph ph-arrow-left"></i></button><figure class="lightbox__stage"><img class="lightbox__image" alt=""></figure><button type="button" class="lightbox__arrow lightbox__arrow--next" data-lightbox-step="1" aria-label="Photo suivante"><i class="ph ph-arrow-right"></i></button><div class="lightbox__footer"><span class="lightbox__counter"></span><div class="lightbox__thumbs"></div></div>';
    document.body.appendChild(vi);
    var viImg = vi.querySelector(".lightbox__image"),
      viN = 0,
      viAvant = null;
    function src(f) {
      var im = f.querySelector("img"),
        u = im.getAttribute("data-hd") || im.currentSrc || im.src,
        w = Math.min(
          2400,
          Math.ceil((Math.max(screen.width, screen.height) * (window.devicePixelRatio || 1)) / 200) * 200,
        );
      return u.replace(/([?&]width=)\d+/, "$1" + w);
    }
    window.MdsVisionneuse = function () {
      vi.querySelector(".lightbox__thumbs").innerHTML = vues
        .map(function (f, i) {
          return (
            '<button type="button" class="lightbox__thumb" data-vi="' +
            i +
            '" aria-label="Photo ' +
            (i + 1) +
            '"><img class="lightbox__thumb-image" src="' +
            attr(f.querySelector("img").src.replace(/([?&]width=)\d+/, "$1200")) +
            '" alt="" loading="lazy"></button>'
          );
        })
        .join("");
    };
    window.MdsVisionneuse();
    function montrer(i) {
      viN = (i + vues.length) % vues.length;
      var n = viN,
        u = src(vues[n]),
        im0 = vues[n].querySelector("img"),
        bas = im0.currentSrc || im0.src,
        pret = false;
      var poserVi = function (url) {
        if (n !== viN || viImg.getAttribute("src") === url) return;
        viImg.src = url;
        viImg.alt = im0.alt;
        viImg.classList.toggle("is-cutout", /(^|\s)image-crop--/.test(im0.className));
        viImg.classList.add("is-visible");
      };
      var finale = function () {
        pret = true;
        poserVi(u);
      };
      decoder(u).then(finale, finale);
      setTimeout(function () {
        if (!pret && bas)
          decoder(bas).then(function () {
            if (!pret) poserVi(bas);
          });
      }, 60);
      vues.forEach(function (g, k) {
        setTimeout(
          function () {
            decoder(src(g));
          },
          Math.abs(k - n) * 120,
        );
      });
      vi.querySelector(".lightbox__counter").textContent = viN + 1 + " / " + vues.length;
      vi.querySelectorAll("[data-vi]").forEach(function (b, j) {
        b.setAttribute("aria-current", j === viN);
      });
    }
    function viOuvrir(i) {
      viAvant = document.activeElement;
      vi.hidden = false;
      document.body.classList.add("has-open-lightbox");
      montrer(i);
      requestAnimationFrame(function () {
        vi.classList.add("is-open");
      });
      vi.querySelector("[data-lightbox-close]").focus({ preventScroll: true });
    }
    function viFermer() {
      vi.classList.remove("is-open");
      document.body.classList.remove("has-open-lightbox");
      setTimeout(function () {
        vi.hidden = true;
      }, 250);
      if (viAvant) viAvant.focus({ preventScroll: true });
    }
    vues.forEach(function (f) {
      f.addEventListener(
        "pointerenter",
        function () {
          decoder(src(f));
        },
        { passive: true },
      );
    });
    vues.forEach(function (f, i) {
      f.addEventListener("click", function () {
        f.classList.remove("is-zooming");
        viOuvrir(i);
      });
    });
    vi.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) {
        if (e.target === vi || e.target.classList.contains("lightbox__stage")) viFermer();
        return;
      }
      if (b.hasAttribute("data-lightbox-close")) viFermer();
      else if (b.hasAttribute("data-lightbox-step")) montrer(viN + +b.getAttribute("data-lightbox-step"));
      else if (b.hasAttribute("data-vi")) montrer(+b.getAttribute("data-vi"));
    });
    document.addEventListener("keydown", function (e) {
      if (vi.hidden) return;
      if (e.key === "Escape") viFermer();
      if (e.key === "ArrowLeft") montrer(viN - 1);
      if (e.key === "ArrowRight") montrer(viN + 1);
    });
    var tx = null;
    vi.addEventListener(
      "touchstart",
      function (e) {
        tx = e.touches[0].clientX;
      },
      { passive: true },
    );
    vi.addEventListener("touchend", function (e) {
      if (tx === null) return;
      var d = e.changedTouches[0].clientX - tx;
      if (Math.abs(d) > 50) montrer(viN + (d < 0 ? 1 : -1));
      tx = null;
    });
  }

  (function () {
    var lentes = Array.prototype.slice.call(document.querySelectorAll("[data-zoom] img[loading=lazy]"));
    function montrerGaleries() {
      document.querySelectorAll(".product-gallery").forEach(function (g) {
        g.classList.add("is-ready");
      });
    }
    var co = navigator.connection;
    if (co && (co.saveData || /2g/.test(co.effectiveType || ""))) {
      montrerGaleries();
      return;
    }
    function charger() {
      montrerGaleries();
      lentes.forEach(function (im, k) {
        setTimeout(function () {
          im.loading = "eager";
        }, k * 150);
      });
      if (P && P.coloris)
        P.coloris.slice(0, 10).forEach(function (c, k) {
          setTimeout(
            function () {
              if (c.photos) decoder(c.photos[0]);
            },
            1200 + k * 300,
          );
        });
    }
    var fait = false,
      gestes = ["pointerdown", "touchstart", "keydown", "scroll", "mousemove"];
    function une() {
      if (fait) return;
      fait = true;
      gestes.forEach(function (x) {
        removeEventListener(x, une, true);
      });
      charger();
    }
    gestes.forEach(function (x) {
      addEventListener(x, une, { passive: true, capture: true });
    });
    function apres() {
      setTimeout(une, 5000);
    }
    if (document.readyState === "complete") apres();
    else window.addEventListener("load", apres);
  })();
  var calme = window.matchMedia("(prefers-reduced-motion: reduce)");
  document.querySelectorAll("[data-accordion] details").forEach(function (d) {
    var s = d.querySelector("summary"),
      c = d.querySelector(".accordion__body");
    if (!s || !c) return;
    s.addEventListener("click", function (e) {
      if (calme.matches || !c.animate) return;
      e.preventDefault();
      if (d._anim) d._anim.cancel();
      var ouvrirA = !d.open,
        h0 = d.open ? c.offsetHeight : 0;
      if (ouvrirA) d.open = true;
      var h1 = ouvrirA ? c.scrollHeight : 0;
      d._anim = c.animate(
        [
          { height: h0 + "px", opacity: ouvrirA ? 0 : 1 },
          { height: h1 + "px", opacity: ouvrirA ? 1 : 0 },
        ],
        { duration: ouvrirA ? 300 : 240, easing: "cubic-bezier(.4,0,.2,1)" },
      );
      d.classList.toggle("is-expanded", ouvrirA);
      d._anim.onfinish = function () {
        d._anim = null;
        if (!ouvrirA) d.open = false;
      };
    });
    d.classList.toggle("is-expanded", d.open);
  });

  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.hasAttribute("data-voir-3d") || a.hasAttribute("data-conseil")) return;
    var id = a.getAttribute("href").slice(1);
    if (!id) return;
    var cible = document.getElementById(id);
    if (!cible) return;
    e.preventDefault();
    var tete = document.querySelector(".site-header"),
      h = tete ? tete.offsetHeight : 0;
    window.scrollTo({
      top: cible.getBoundingClientRect().top + window.scrollY - h - 12,
      behavior: calme.matches ? "auto" : "smooth",
    });
    history.replaceState(history.state, "", "#" + id);
  });

  rendre();
  filtrer();
  if (document.visibilityState)
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") chargerPanier().catch(function () {});
    });
  window.MdsPanier = {
    charger: chargerPanier,
    ajouter: ajouterVariante,
    ouvrir: function () {
      ouvrir("panier");
    },
  };
})();

(function () {
  var survol = window.matchMedia("(hover:hover)");
  function liste(v) {
    var d = v.getAttribute("data-imgs"),
      a = v.querySelector(".product-card__image--scene");
    if (d) return d.split("|");
    return [null, a ? a.getAttribute("src") : null];
  }
  function points(v, i) {
    v.querySelectorAll(".product-card__dot").forEach(function (x, k) {
      x.classList.toggle("is-active", k === i);
    });
  }
  function remettre(v) {
    var l = liste(v),
      a = v.querySelector(".product-card__image--scene");
    v.removeAttribute("data-i");
    v.classList.remove("is-scene", "is-cutout");
    if (v.getAttribute("data-imgs") && a && l[1] && a.getAttribute("src") !== l[1]) {
      a.removeAttribute("srcset");
      a.setAttribute("src", l[1]);
    }
    points(v, 0);
  }
  function precharger(v) {
    if (!v || v.__precharge) return;
    v.__precharge = true;
    liste(v).forEach(function (u) {
      if (u) {
        var im = new Image();
        im.decoding = "async";
        im.src = u;
      }
    });
  }
  function aller(v, pas) {
    precharger(v);
    var l = liste(v),
      n = l.length,
      a = v.querySelector(".product-card__image--scene");
    if (n < 2 || !a) return;
    var dep = v.hasAttribute("data-i")
      ? parseInt(v.getAttribute("data-i"), 10)
      : survol.matches && v.closest(".product-card").matches(":hover")
        ? 1
        : 0;
    var i = (((dep + pas) % n) + n) % n;
    v.setAttribute("data-i", i);
    if (i === 0) {
      v.classList.remove("is-scene");
      v.classList.add("is-cutout");
    } else {
      if (l[i] && a.getAttribute("src") !== l[i]) {
        a.removeAttribute("srcset");
        a.setAttribute("src", l[i]);
      }
      v.classList.remove("is-cutout");
      v.classList.add("is-scene");
    }
    points(v, i);
  }
  function fleches() {
    document.querySelectorAll(".product-card .product-card__media").forEach(function (v) {
      if (
        v.querySelector(".product-card__arrow") ||
        !v.querySelector(".product-card__image--scene") ||
        !v.querySelector(".product-card__image--cutout")
      )
        return;
      var n = liste(v).length;
      if (n < 2) return;
      var t = v.closest(".product-card");
      if (t)
        t.addEventListener("mouseleave", function (e) {
          if (survol.matches && e.pointerType !== "touch") remettre(v);
        });
      ["prev", "next"].forEach(function (cote) {
        var f = document.createElement("span");
        f.className = "product-card__arrow product-card__arrow--" + cote;
        f.setAttribute("role", "button");
        f.tabIndex = 0;
        f.setAttribute("data-step", cote === "prev" ? "-1" : "1");
        f.setAttribute("aria-label", cote === "prev" ? "Photo précédente" : "Photo suivante");
        f.innerHTML = '<i class="ph ph-caret-' + (cote === "prev" ? "left" : "right") + '" aria-hidden="true"></i>';
        v.appendChild(f);
      });
      var p = document.createElement("span");
      p.className = "product-card__dots";
      p.setAttribute("aria-hidden", "true");
      for (var k = 0; k < n; k++) {
        var pt = document.createElement("i");
        pt.className = "product-card__dot";
        p.appendChild(pt);
      }
      v.appendChild(p);
      points(v, 0);
    });
  }
  function basculer(e) {
    var f = e.target.closest && e.target.closest(".product-card__arrow");
    if (!f) return;
    if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();
    e.stopPropagation();
    aller(f.closest(".product-card__media"), +f.getAttribute("data-step"));
  }
  function defile(el) {
    for (var x = el.parentElement; x && x !== document.body; x = x.parentElement) {
      var o = getComputedStyle(x).overflowX;
      if ((o === "auto" || o === "scroll") && x.scrollWidth > x.clientWidth + 2) return true;
    }
    return false;
  }
  document.addEventListener(
    "pointerover",
    function (e) {
      var v = e.target.closest && e.target.closest(".product-card .product-card__media");
      if (v && v.querySelector(".product-card__arrow")) precharger(v);
    },
    { passive: true },
  );
  var depart = null;
  document.addEventListener(
    "touchstart",
    function (e) {
      var v = e.target.closest && e.target.closest(".product-card .product-card__media");
      depart = null;
      if (v && v.querySelector(".product-card__arrow")) precharger(v);
      if (!v || !v.querySelector(".product-card__arrow") || e.touches.length !== 1 || defile(v)) return;
      depart = { v: v, x: e.touches[0].clientX, y: e.touches[0].clientY };
    },
    { passive: true },
  );
  document.addEventListener(
    "touchend",
    function (e) {
      if (!depart) return;
      var t = e.changedTouches[0],
        dx = t.clientX - depart.x,
        dy = t.clientY - depart.y;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        aller(depart.v, dx < 0 ? 1 : -1);
        depart.v.closest(".product-card").setAttribute("data-glisse", Date.now());
      }
      depart = null;
    },
    { passive: true },
  );
  document.addEventListener(
    "click",
    function (e) {
      var t = e.target.closest && e.target.closest(".product-card[data-glisse]");
      if (!t) return;
      if (Date.now() - parseInt(t.getAttribute("data-glisse"), 10) < 500) {
        e.preventDefault();
        e.stopPropagation();
      }
      t.removeAttribute("data-glisse");
    },
    true,
  );
  document.addEventListener("click", basculer, true);
  document.addEventListener("keydown", basculer, true);
  fleches();
  var attente = null;
  new MutationObserver(function () {
    clearTimeout(attente);
    attente = setTimeout(fleches, 60);
  }).observe(document.body, { childList: true, subtree: true });
})();
